import { OptionFilterItem } from './grid-column.model';

export enum NotificationType {
  Alert = 0,
  Notification = 1,
  'Urgent alert' = 2
}

export enum NotificationStatus {
  Draft = 0,
  Published = 1,
  Archived = 2
}

export enum UserNotificationStatus {
  New = 0,
  Hidden = 1,
  Dismiss = 2
}

export enum UserNotificationSource {
  SolveIt = 0
}

export const NOTIFICATION_TYPE_OPTIONS: OptionFilterItem[] = [
  {
    text: NotificationType[NotificationType.Notification],
    value: NotificationType.Notification
  },
  {
    text: NotificationType[NotificationType.Alert],
    value: NotificationType.Alert
  },
  {
    text: NotificationType[NotificationType['Urgent alert']],
    value: NotificationType['Urgent alert']
  }
];

export const NOTIFICATION_STATUS_OPTIONS: OptionFilterItem[] = [
  {
    text: NotificationStatus[NotificationStatus.Draft],
    value: NotificationStatus.Draft
  },
  {
    text: NotificationStatus[NotificationStatus.Published],
    value: NotificationStatus.Published
  },
  {
    text: NotificationStatus[NotificationStatus.Archived],
    value: NotificationStatus.Archived
  }
];

export interface UserNotificationItem {
  notificationId: string;
  type: NotificationType;
  status: UserNotificationStatus;
  title: string;
  briefDescription: string;
  description: string;
  notificationSource: string;
  publishDate: Date;
  deleted?: boolean;
}

export interface NotificationListItem {
  notificationId: string;
  type: NotificationType;
  countryCode: string;
  countryName: string;
  title: string;
  briefDescription: string;
  description: string;
  status: NotificationStatus;
  publishDate: Date;
  endDate: Date;
  createdAt: Date;
  createdBy: string;
  createdByName: string;
  lastUpdatedAt: Date;
  lastUpdatedBy: string;
  lastUpdatedByName: string;
}

export interface NotificationSave {
  countryCodes: string[] | string;
  type: NotificationType;
  title: string;
  briefDescription: string;
  description: string;
  endDate: Date;
}
export interface NotificationEdit extends NotificationSave {
  notificationId: string;
}

export interface NotificationSaveConfig {
  notification: NotificationSave;
  isPublish?: boolean;
}
export interface NotificationEditConfig {
  notification: NotificationEdit;
  isPublish?: boolean;
}
